import React, { forwardRef } from 'react'
import { FlexProps } from './Flex.types'
import Box from '../Box/Box'

const Flex = forwardRef<HTMLDivElement, FlexProps>(
  (
    {
      direction = 'row',
      wrap = 'nowrap',
      align,
      justify,
      inline = false,
      alignItems,
      justifyContent,
      flexDirection,
      flexWrap,
      ...props
    },
    ref
  ) => {
    return (
      <Box
        ref={ref}
        display={inline ? 'inline-flex' : 'flex'}
        flexDirection={flexDirection || direction}
        flexWrap={flexWrap || wrap}
        alignItems={alignItems || align}
        justifyContent={justifyContent || justify}
        {...props}
      />
    )
  }
)

Flex.displayName = 'Flex'

export default Flex
